export const formValidation = (formReference) => {
    const selectElements = formReference.querySelectorAll('select');
    const inputElements = formReference.querySelectorAll('.umbraco-forms-field-wrapper input');
    const submitElement = formReference.querySelector('button[type=submit]');
    let count = 0;
    const fieldCount = selectElements.length + inputElements.length;
    selectElements.forEach((select) => {
        select.addEventListener('change', (e) => {
            const theTarget = e.currentTarget;
            const theValue = theTarget.value;
            if (theValue !== '') {
                select.classList.add('filled');
                count++;
            }
            else {
                select.classList.remove('filled');
                count--;
            }
            if (count === fieldCount) {
                submitElement?.removeAttribute('disabled');
            }
            else {
                submitElement?.setAttribute('disabled', 'disabled');
            }
        });
    });
    inputElements.forEach((input) => {
        input.addEventListener('blur', (e) => {
            const theTarget = e.currentTarget;
            const theValue = theTarget.value;
            if (theValue !== '') {
                theTarget.classList.add('filled');
                count++;
            }
            else {
                theTarget.classList.remove('filled');
                count--;
            }
            if (count === fieldCount) {
                submitElement?.removeAttribute('disabled');
            }
            else {
                submitElement?.setAttribute('disabled', 'disabled');
            }
        });
    });
};
